<template>
  <div v-cloak>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: $t('Id'), sort: 'Id' },
            { title: $t('CreateOn'), sort: 'CreateOn' },
            { title: $t('Header'), sort: 'Header' },
            { title: $t('Contents'), sort: 'Content' },
            { title: $t('FullName'), sort: 'FullName' },
            { title: $t('Email'), sort: 'Email' },
            { title: $t('PhoneNumber'), sort: 'PhoneNumber' },
            { title: $t('OrderId'), sort: 'OrderId' },
            { title: $t('Status'), sort: 'Status' },
            { title: $t('Action') },
          ]"
        >
          <template slot-scope="{ row }">
                        <td style="width: 32%">
              {{ row.id }}
            </td>
            <td style="width: 15%; direction: ltr">
              {{ row.createOn.split(" ")[0] }}<br />{{
                row.createOn.split(" ")[1]
             }}
            </td>
            <td style="width: 15%">
              {{ row.header }}
            </td>
            <td style="width: 27%">
              {{ row.content }}
            </td>
            <td style="width: 27%">
              {{ row.fullname }}
            </td>
            <td style="width: 27%">
              {{ row.emailAddress }}
            </td>
            <td style="width: 27%">
              {{ row.phone }}
            </td>
            <td style="width: 27%">
              {{ row.orderId }}
            </td>
            <td style="width: 27%">
              {{ row.status }}
            </td>
            <td style="width: 8%">
              <vs-button
                radius
                color="success"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-eye"
                @click.prevent="modifyComment(row)"
                class="d-inline"
                v-has-permission="permission185"
              ></vs-button>
            </td>
          </template>
        </data-grid>
      </div>
    </div>
    <modify-popup
      :show="ModifyPopup"
      :model="modalModel"
      @finish="onfinish"
      @close="closeModifyPopup"
    ></modify-popup>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./ModifyPopup.vue";

export default {
  name: "Content_managment_Complaints_Pending_Index",
  components: {
    ModifyPopup,
    DataGrid,
  },
  data() {
    return {
      permission185: "ModifyCmsCategory",
      ModifyPopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "CMS/api/ComplaintsQuery?status=0&",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },

  methods: {
    modifyComment(model) {
      this.modalModel = {
        id: model.id,
        description: model.header,
      };
      this.ModifyPopup = true;
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
